<template>
  <div id="app">
    <Loading :show="loading.isLoading" :messages="loading.messages"/>
    <Modal :show="modal.isModal" :messages="modal.messages" @child_close="hasTokenReload($event)"/>
    <header>
      <Navbar />
    </header>
    <template v-if="env_mode === 'develop'">
      <div class="develop">
        開発環境でアクセス中
      </div>
    </template>
    <main>
      <router-view/>
    </main>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Loading from './components/Loading.vue'
import Modal from './components/Modal'
import {mapActions } from 'vuex'   //Vuex が提供する mapState 関数を使う
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

import { INTERNAL_SERVER_ERROR, UNAUTHORIXED } from './util.js'

export default {
  name: 'App',
  components: {
    Navbar,
    Loading,
    Modal,
  },
  data: function(){
    return {
      modal: {
        isModal: false,
        messages: 'しばらくアクセスがありませんでした。\n再度ログインを行ってください。',
      }
    }
  },
  computed: {
    errorCode() {
      return this.$store.state.error.code
    },
    loading() {
      return {
        isLoading: this.$store.state.loading.isLoading,
        messages : this.$store.state.loading.loadingMessages,
      }
    },
    env_mode(){
      return process.env.VUE_APP_ENV_MODE
    }
  },
  watch: {
    errorCode: {
      handler (val) {
        if(val === INTERNAL_SERVER_ERROR) {
          this.$router.push('/500')
        }
        if(val === UNAUTHORIXED) {
          this.modal.isModal = true
        }
      },
      immediate: true
    },
    $route() {
      this.$store.commit('error/setCode', null)
      this.$store.commit('loading/setLoadingStatus', { loading: false, message: '' } )
    },
  },
  methods:{
    ...mapActions({
      logout: 'auth/logout',
    }),
    hasTokenReload(){
      this.logout()
      this.modal.isModal = false

      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.develop{
  position: relative;
}
</style>
